/* unplugin-vue-components disabled */import script from "./TravelManager2.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelManager2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__